import "@babel/polyfill";
import "url-search-params-polyfill";
import $ from 'jquery';
import "../sass/index.scss";
import * as Site from "../js/site";
import * as EsriMap from "./map";
import * as Search from "./search";
import * as Print from "./print";
import * as Constants from "./constants";

let mapView, idParams, parcelIdTask, zoningIdTask, egDataIdTask;
let findParams, findParcelTask;
let EsriModules;
let taskCompleteCount;
let selectedParcel = null;
let selectedParcelCenter = null;
let selectedParcelZoom = 0;
let zoningAttributes = null;
let overlayZones = [];
let apnMatchList = [];
let addressMatchList = [];
let queryApn = "";
let queryAddress = "";

let minZoomLevel = 12;
let maxZoomLevel = 20;
let zoomInActive = true;
let zoomOutActive = true;
let fullExtent = null;
let needZoomInfo = false;
let waitingForView = false;

init();

function init() {
  console.log("index.init");
  let promise = new Promise((resolve, reject) => {
    let japiObjects = EsriMap.initMap();
    resolve(japiObjects);
  });
  promise.then(function (response) {
    EsriModules = response;

    mapView = EsriModules.mapView;
    mapView.when(mapViewReady);

    parcelIdTask = new EsriModules.IdentifyTask(Constants.parcelUrl);
    zoningIdTask = new EsriModules.IdentifyTask(Constants.zoningUrl);
    egDataIdTask = new EsriModules.IdentifyTask(Constants.egDataUrl);

    findParams = new EsriModules.FindParameters();
    findParams.contains = true;
    findParams.returnGeometry = true;
    findParams.layerIds = [0];

    findParcelTask = new EsriModules.FindTask(Constants.parcelUrl);

    $("#map-zoom-level").show();
    $("#map-navigation").show();

    Search.initSearch();

    Print.initPrint(mapView,
      EsriModules.PrintTask, EsriModules.PrintTemplate, EsriModules.PrintParameters,
      getSelectedParcelAttributes
    );
  });

  Site.initSite();

  let ozInfo = Constants.overlayZoneInfo;
  for (let idx = 0; idx < ozInfo.length; idx++) {
    overlayZones.push({ name: ozInfo[idx].name, inZone: "No" });
  }

  $("body").keypress(function (e) {
    if (e.keyCode == 13) {
      console.log("Enter key - input id = " + e.target.id);
      switch (e.target.id) {
        case "main-apn-input":
          findApn();
          break;
        case "main-address-input":
          findAddress();
          break;
        case "main-print-title-input":
          Print.createMapImage();
          break;
      }
    }
  });

  $("#mnb-0").click(function () { zoomIn(); });
  $("#mnb-1").click(function () { zoomOut(); });
  $("#mnb-2").click(function () { zoomToFullExtent(); });

  $("#map-identify-zoom-to-parcel").click(function () { zoomToParcel(); });

  $("#main-search-apn-button").click(function () { findApn(); });
  $("#main-search-apn-match-0").click(function () { parcelApnSelected(0); });
  $("#main-search-apn-match-1").click(function () { parcelApnSelected(1); });
  $("#main-search-apn-match-2").click(function () { parcelApnSelected(2); });
  $("#main-search-apn-match-3").click(function () { parcelApnSelected(3); });
  $("#main-search-apn-match-4").click(function () { parcelApnSelected(4); });

  $("#main-search-address-button").click(function () { findAddress(); });
  $("#main-search-address-match-0").click(function () { parcelAddressSelected(0); });
  $("#main-search-address-match-1").click(function () { parcelAddressSelected(1); });
  $("#main-search-address-match-2").click(function () { parcelAddressSelected(2); });
  $("#main-search-address-match-3").click(function () { parcelAddressSelected(3); });
  $("#main-search-address-match-4").click(function () { parcelAddressSelected(4); });

  const params = new URLSearchParams(window.location.search);
  let param = params.get("apn");
  queryApn = param ? param : "";
  param = params.get("address");
  queryAddress = param ? param : "";
  console.log("Query apn = " + queryApn + ", address = " + queryAddress);
}

function initOverlayZones() {
  let ozInfo = Constants.overlayZoneInfo;
  for (let idx = 0; idx < ozInfo.length; idx++) {
    overlayZones[idx].inZone = "No";
  }
}

function mapViewReady() {
  mapView.on("click", identifyParcel);
  mapView.watch("extent", mapExtentHasChanged);
  mapView.watch("updating", mapIsUpdating);
  // Use 65% of the full extent of the zoning layer for the overall full extent (home button)
  // The full extent is not available for the layer until it has completely initialized.
  let ezl;
  let layers = mapView.map.layers.items;
  for (let idx = 0, len = layers.length; idx < len; idx++) {
    if (layers[idx].id === "ezoningLayer") {
      ezl = layers[idx];
      ezl.when(function () {
        fullExtent = ezl.fullExtent.expand(.65);
      });
      break;
    }
  }

  idParams = new EsriModules.IdentifyParameters({
    tolerance: 3,
    width: mapView.width,
    height: mapView.height
  });

  if (queryApn !== "") {
    $("#main-apn-input").val(queryApn);
    Site.showParcelSearchContainer();
    findApn();
  } else if (queryAddress !== "") {
    $("#main-address-input").val(queryAddress);
    Site.showParcelSearchContainer();
    findAddress();
  }
}

function zoomToParcel() {
  console.log("zoomToParcel");
  mapView.goTo({
    target: selectedParcelCenter,
    zoom: selectedParcelZoom
  });
}

function zoomToFullExtent() {
  mapView.goTo(fullExtent);
}
function zoomIn() {
  if (zoomInActive) mapView.zoom = mapView.zoom + 1;
}
function zoomOut() {
  if (zoomOutActive) mapView.zoom = mapView.zoom - 1;
}
function mapExtentHasChanged() {
  console.log("mapScaleHasChanged zoom=" + mapView.zoom + ", scale=" + mapView.scale);
  let crntZoom = mapView.zoom;
  if (crntZoom >= maxZoomLevel) {
    zoomInActive = false;
    $("#mnb-0").addClass("zoom-inactive");
  } else {
    zoomInActive = true;
    $("#mnb-0").removeClass("zoom-inactive");
  }
  if (crntZoom <= minZoomLevel) {
    zoomOutActive = false;
    $("#mnb-1").addClass("zoom-inactive");
  } else {
    zoomOutActive = true;
    $("#mnb-1").removeClass("zoom-inactive");
  }
  $("#map-zoom-level").html("Level: " + parseInt(mapView.zoom));
}
function mapIsUpdating(isUpdating) {
  if (needZoomInfo) {
    needZoomInfo = false;
    waitingForView = true;
  }
  if (isUpdating) return;

  console.log("mapIsUpdating isUpdating=" + isUpdating);
  if (waitingForView) {
    let extToBig = false;
    let mapExt = mapView.extent;
    let geoExt = selectedParcel.geometry.extent;
    if (geoExt.xmin < mapExt.xmin || geoExt.xmax > mapExt.xmax) {
      extToBig = true;
    } else if (geoExt.ymin < mapExt.ymin || geoExt.ymax > mapExt.ymax) {
      extToBig = true;
    }
    if (extToBig) {
      console.log("mapIsUpdating extToBig");
      mapView.goTo({
        target: selectedParcel.geometry
      });
    } else {
      waitingForView = false;
      selectedParcelZoom = mapView.zoom;
    }
  }

}

function getSelectedParcelAttributes() {
  console.log("getSelectedParcelAttributes");
  if (selectedParcel) {
    zoomToParcel();
  }
  let apn = "N/A";
  let addr = "N/A";
  if (selectedParcel) {
    apn = selectedParcel.attributes.APN;
    addr = selectedParcel.attributes.SitusStreet === "Null" || selectedParcel.attributes.SitusStreet === "" ? "N/A" : selectedParcel.attributes.SitusStreet;
  }
  return {
    parcel: { APN: apn, SitusStreet: addr },
    zoning: zoningAttributes,
    overlayZones: overlayZones
  }
}

function identifyParcel(event, geoPoint) {
  Site.displayMessage("#map-identify", "Retrieving map information...");

  selectedParcel = null;
  taskCompleteCount = 0;
  mapView.graphics.removeAll();
  Site.hidePrintButton();

  if (geoPoint) {
    let dist = 100;
    idParams.geometry = geoPoint;
    //idParams.mapExtent = mapView.map.layers.items[0].fullExtent;
    idParams.mapExtent = new EsriModules.Extent({
      xmin: geoPoint.x - dist,
      xmax: geoPoint.x + dist,
      ymin: geoPoint.y - dist,
      ymax: geoPoint.y + dist,
      spatialReference: mapView.spatialReference
    });
  } else {
    idParams.geometry = event.mapPoint;
    idParams.mapExtent = mapView.extent;
  }
  idParams.layerIds = [0];
  idParams.layerOption = "all"; // Parcel layer has visibility threshold. Override it.
  idParams.returnGeometry = true;

  parcelIdTask.execute(idParams)
    .then(function (response) {
      taskCompleteCount++;
      let results = response.results;
      if (results.length === 0) {
        $("#map-identify-parcel-info").hide();
        $("#map-identify-no-parcel-info").show();
      } else {
        selectedParcel = results[0].feature;
        Search.buildParcelHtml(results[0].feature.attributes);
        highlightSelectedParcel();
      }

      $("#map-identify-instructions").hide();
      $("#map-identify-result-container").show();
      if (taskCompleteCount === 3) Site.hideInfo("#map-identify");
    })
    .catch(function (error) {
      Site.displayError("#map-identify", "Parcel identify error: " + error.message);
      console.log("Parcel identify error: ", error.message);
    });

  identifyZoning();
  identifyAdditionalZones();
}

function identifyZoning() {
  idParams.layerIds = [0];
  idParams.layerOption = "top";
  idParams.returnGeometry = false;
  zoningIdTask.execute(idParams)
    .then(function (response) {
      taskCompleteCount++;
      let html;
      let results = response.results;
      let zoneElem = $("#map-identify-zoning-info");
      if (results.length === 0) {
        zoningAttributes = null;
        html = "No zoning information for that location.";
        zoneElem.html(html);
      } else {
        $("#header-right-menu-print").show();
        $("#header-right-toolbar-print").show();
        zoningAttributes = results[0].feature.attributes;
        if (results.length === 1) {
          html = Search.buildZoningHtml(results[0].feature.attributes);
          zoneElem.html(html);
        } else {
          zoneElem.empty();
          let div1 = $("<div />", {
            class: "multi-zone-header"
          });
          let div2 = $("<div />", {
            text: "Multiple Zones Found"
          });
          div1.append(div2);
          let divNav = $("<div />", {
            class: "navbar"
          });
          let icon = $("<i />", {
            class: "arrow fas fa-angle-double-left",
            title: "Show previous zone info"
          }).on("click", {}, navigateMultipleResult);
          divNav.append(icon);
          div2 = $("<div />", {
            id: "multiple-zones-title",
            class: "info",
            text: "1 of " + results.length
          });
          divNav.append(div2);
          icon = $("<i />", {
            class: "arrow fas fa-angle-double-right",
            title: "Show next feature"
          }).on("click", {}, navigateMultipleResult);
          divNav.append(icon);
          div1.append(divNav);
          zoneElem.append(div1);

          for (let idx = 0; idx < results.length; idx++) {
            html = Search.buildZoningHtml(results[idx].feature.attributes);
            div2 = $("<div />", {
              id: "multiple-zones-detail-" + idx,
              html: html
            });
            if (idx > 0) div2.prop("style", "display:none");
            zoneElem.append(div2);
          }
        }
      }

      if (taskCompleteCount === 3) Site.hideInfo("#map-identify");
    })
    .catch(function (error) {
      Site.displayError("#map-identify", "Zoning identify error: " + error.message);
      console.log("Zoning identify error: ", error.message);
    });
}

function navigateMultipleResult(event) {
  console.log("navigateMultipleResult");
  let increment = (event.currentTarget.title.indexOf("next") < 0) ? -1 : 1;
  let titleObj = $("#multiple-zones-title");
  let parts = titleObj.html().split(" ");
  let crntIdx = parseInt(parts[0]);
  let lastIdx = parseInt(parts[2]);
  let nextIdx = crntIdx + increment;
  if (nextIdx === 0) {
    nextIdx = lastIdx;
  } else if (nextIdx > lastIdx) {
    nextIdx = 1;
  }

  $("#multiple-zones-detail-" + (crntIdx - 1)).hide();
  $("#multiple-zones-detail-" + (nextIdx - 1)).show();

  titleObj.text(nextIdx + " of " + lastIdx);
}

function identifyAdditionalZones() {
  initOverlayZones();
  idParams.layerIds = [];
  let ozInfo = Constants.overlayZoneInfo;
  for (let idx = 0; idx < ozInfo.length; idx++) {
    idParams.layerIds.push(ozInfo[idx].layerId);
  }
  idParams.layerOption = "all";
  idParams.returnGeometry = false;
  egDataIdTask.execute(idParams)
    .then(function (response) {
      taskCompleteCount++;
      let html;
      let results = response.results;
      if (results.length === 0) {
        $("#map-identify-additional-info").html("No additional information for that location.");
      } else {
        Search.buildAdditionalZonesHtml(results, $("#map-identify-additional-info"), overlayZones);
      }

      if (taskCompleteCount === 3) Site.hideInfo("#map-identify");
    })
    .catch(function (error) {
      Site.displayError("#map-identify", "Additional zone info identify error: " + error.message);
      console.log("Additional zone info identify error: ", error.message);
    });
}

function findApn() {
  $("#main-search-apn-multiple-match").hide();

  let apn = $.trim($("#main-apn-input").val());
  if (apn === "") return;

  selectedParcel = null;
  mapView.graphics.removeAll();
  Site.hidePrintButton();

  findParams.searchFields = ["APN"];
  findParams.searchText = apn;
  Site.displayMessage("#main-search-parcel", "Searching for parcel...");
  console.log("Searching for : " + findParams.searchText);

  findParcelTask.execute(findParams)
    .then(function (response) {
      let results = response.results;
      if (results.length === 0) {
        Site.displayError("#main-search-parcel", "Parcel number not found.");
        $("#map-identify-result-container").hide();
        $("#map-identify-instructions").show();
        return;
      }

      apnMatchList.length = 0;
      if (results.length === 1) {
        apnMatchList.push(results[0].feature);
        parcelApnSelected(0);
      } else {
        let numResults = results.length;
        for (let idx = 0; idx < 5; idx++) {
          if (idx < numResults) {
            apnMatchList.push(results[idx].feature);
            let attr = results[idx].feature.attributes;
            let addr = attr.SitusStreet === "Null" ? "" : attr.SitusStreet;
            $("#main-search-apn-match-" + idx).html("APN: " + attr.APN + "<br/>Address: " + addr);
            $("#main-search-apn-match-" + idx).show();
          } else {
            $("#main-search-apn-match-" + idx).hide();
          }
        }
        Site.hideInfo("#main-search-parcel");
        $("#main-search-apn-multiple-match").show();
        $("#map-identify-result-container").hide();
        $("#map-identify-instructions").show();
      }
    })
    .catch(function (error) {
      Site.displayError("#main-search-parcel", "Find parcel error: " + error.message);
      $("#map-identify-result-container").hide();
      $("#map-identify-instructions").show();
      console.log("Find parcel error: ", error.message);
    });
}

function findAddress() {
  $("#main-search-address-multiple-match").hide();

  let addr = $.trim($("#main-address-input").val());
  if (addr === "") return;

  Site.displayMessage("#main-search-parcel", "Searching for address...");

  mapView.graphics.removeAll();
  Site.hidePrintButton();

  let locator = new EsriModules.Locator();
  locator.outFields = ["*"];
  locator.singleLineFieldName = "Address";
  locator.url = Constants.locatorUrl;
  locator.outSpatialReference = new EsriModules.SpatialReference(3857);
  // let address = {
  //   address: {
  //     Street: addr //"1988 Village Park Way"//"505 s vulcan"
  //   }
  // };
  let address = {
    address: {
      address: addr //"1988 Village Park Way"//"505 s vulcan"
    }
  };

  locator.addressToLocations(address)
    .then(function (response) {
      addressMatchList.length = 0;
      switch (response.length) {
        case 0:
          Site.displayError("#main-search-parcel", "Address not found.");
          return;
        case 1:
          Site.displayMessage("#main-search-parcel", "Address found.<br/>" + response[0].address);
          addressMatchList.push(response[0].location);
          parcelAddressSelected(0);
          break;
        case 2:
          let idxToUse = -1;
          if (response[0].address.slice(-2) === "MP") {
            idxToUse = 1;
          }
          if (response[1].address.slice(-2) === "MP") {
            if (idxToUse === -1) {
              idxToUse = 0;
            } else {
              idxToUse = -1; // Both have MP so let user decide
            }
          }
          if (idxToUse > -1) {
            Site.displayMessage("#main-search-parcel", "Address found.<br/>" + response[idxToUse].address);
            addressMatchList.push(response[idxToUse].location);
            parcelAddressSelected(0);
            break;
          }
        default:
          let numResponses = response.length;
          for (let idx = 0; idx < 5; idx++) {
            if (idx < numResponses) {
              addressMatchList.push(response[idx].location);
              $("#main-search-address-match-" + idx).html("Score: " + response[idx].score + "<br/>Address: " + response[idx].address);
              $("#main-search-address-match-" + idx).show();
            } else {
              $("#main-search-address-match-" + idx).hide();
            }
          }
          Site.hideInfo("#main-search-parcel");
          $("#main-search-address-multiple-match").show();
          return;
      }
    }).catch(function (error) {
      Site.displayError("#main-search-parcel", "Find parcel error: " + error.message);
      $("#map-identify-result-container").hide();
      $("#map-identify-instructions").show();
      console.log("Find parcel error: ", error.message);
    });
}

function parcelApnSelected(idx) {
  Search.buildParcelHtml(apnMatchList[idx].attributes);
  selectedParcel = apnMatchList[idx];
  highlightSelectedParcel();

  taskCompleteCount = 1;

  idParams.geometry = selectedParcel.geometry.centroid;
  idParams.mapExtent = selectedParcel.geometry.extent;

  identifyZoning();
  identifyAdditionalZones();

  $("#map-identify-instructions").hide();
  $("#map-identify-result-container").show();
  Site.hideInfo("#main-search-parcel");

  Site.toggleParcelSearchContainer();
}

function parcelAddressSelected(idx) {
  let point = new EsriModules.Point({
    x: addressMatchList[idx].x,
    y: addressMatchList[idx].y,
    spatialReference: mapView.spatialReference
  });

  Site.toggleParcelSearchContainer();

  identifyParcel(null, point);
}

function highlightSelectedParcel() {
  $("#map-identify-parcel-info").show();
  $("#header-right-menu-print").show();
  $("#header-right-toolbar-print").show();
  $("#map-identify-no-parcel-info").hide();

  let symbol = {
    type: "simple-fill",  // autocasts as new SimpleFillSymbol()
    color: [51, 51, 204, 0.75],
    style: "solid",
    outline: {  // autocasts as new SimpleLineSymbol()
      color: "white",
      width: 1
    }
  };
  let parcelGraphic = new EsriModules.Graphic({
    geometry: selectedParcel.geometry,
    symbol: symbol
  });
  mapView.graphics.removeAll();
  mapView.graphics.add(parcelGraphic);

  needZoomInfo = true;
  selectedParcelZoom = 19;
  selectedParcelCenter = selectedParcel.geometry.extent.center;

  zoomToParcel();
}